import React, { Component } from "react";

import Button from "@material-ui/core/Button";
import Drawer from "@material-ui/core/Drawer";
import Menu from "@material-ui/core/Menu";
import { Menu as MenuIcon } from "@material-ui/icons";

import "./Header.css";
export default class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      drawerOpen: false,
      communityEl: null,
      facultyEl: null,
      displayRoute: props.displayRoute,
    };
    this.routes = [
      {
        name: "Home",
        link: "/",
      },
      {
        name: "Committee",
        link: "/committee",
      },
      {
        name: "Faculty",
        link: "/faculty",
      },

      {
        name: "Scientific Program",
        link: "/scientific-program",
      },
      // {
      //   name: "Workshop",
      //   link: "/workshop",
      // },
      // {
      //   name: "Travel & Accomodation",
      //   link: "/travel-and-accomodation",
      // },
      {
        name: "Near by Places",
        link: "/nearby-places",
      },
      {
        name: "Contact",
        link: "/contact",
      },

      // {
      //   name: "Trip",
      //   link: "/trip",
      // },
    ];

    this.eventCommittee = [
      {
        name: "Organizing Committee",
        link: "/organizing-committee",
      },
      {
        name: "Scientific Committee Members",
        link: "/scientific-commitee-members",
      },
      {
        name: "Advisory Members",
        link: "/advisory-members",
      },
    ];

    this.IACExecutive = [
      {
        name: "IAC Executive Members",
        link: "/iac-executive-members",
      },
      {
        name: "Senior Residents",
        link: "/senior-residents",
      },
      {
        name: "Junior Residents",
        link: "/junior-residents",
      },
      {
        name: "PDCC/ PHD Courses",
        link: "/pdcc-phd",
      },
    ];

    this.csiCommittee = [
      {
        name: "CSI UP Chapter",
        link: "/csi-up-chapter",
      },
      {
        name: "National CSI Office Bearers",
        link: "/national-csi-office-bearers",
      },
    ];
  }

  componentDidUpdate(prevProps) {
    if (this.props.history.location.pathname !== prevProps.history.location.pathname) {
      this.setState({ drawerOpen: false });
    }
    if (this.props.match.params.name !== prevProps.match.params.name) {
      this.setState({ communityEl: null, open: false });
    }
  }

  handleOpen = (event, type) => {
    if (type === "community") {
      this.setState({ communityEl: event.currentTarget, open: true });
    } else {
      this.setState({ facultyEl: event.currentTarget, open: true });
    }
  };

  handleClose = () => {
    this.setState({ communityEl: null, facultyEl: null, open: false });
  };

  navigateTo = (route) => {
    if (route === "/contact") {
      const footer = document.getElementById("footer");
      footer.scrollIntoView({ behavior: "smooth" });
    } else {
      this.props.history.push(route);
    }
    this.toggleDrawer(false);
  };

  toggleDrawer = (toggle) => {
    this.setState({ drawerOpen: toggle });
  };

  scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    this.setState({ drawerOpen: false });
  };

  render() {
    return (
      <header className="header">
        <div className="nav-row-1">
          <div className="row-1-left">
            <div className="row-1-left">
              {/* Desktop Button */}
              <a href="/cytocon-2026-brochure-new.pdf" target="_blank" rel="noreferrer noopener" className="desktop-only">
                <Button color="primary" variant="contained">
                  View Brochure
                </Button>
              </a>

              {/* Mobile Button */}
              <div className="mobile-only" onClick={() => this.navigateTo("/registration")}>
                <Button color="primary" variant="contained">
                  Register Now
                </Button>
              </div>
            </div>
          </div>
          <div className="nav-logos">
            <div className="nav-logo-images">
              <img src="/naac-pgi.png" alt="NAAC Logo" />
              <img src="/nirf-sgpgims.png" alt="nirf sgpgims Logo" />
              <img src="/pgi.png" alt="PGI Logo" />
              <img src="/iac.png" alt="IAC Logo" />
              {/* <img src="/cytocon-newlogo.png" alt="Cytocon 2026" style={{ height: "50px" }} /> */}
            </div>
          </div>
        </div>
        <div className="nav-row-2">
          <div className="nav-wrapper">
            {/* logo image */}
            <div className="logo" onClick={() => this.navigateTo("/")}>
              <img src="/cytocon-newlogo.png" alt="logo" />
            </div>
            {/* nav links */}

            <nav className="nav-links">
              {this.routes.map((route, index) => {
                if (route.name === "Committee") {
                  return (
                    <>
                      <Button key={index} className="link-btn" onClick={(e) => this.handleOpen(e, "community")}>
                        Committee
                      </Button>
                      <Menu
                        anchorEl={this.state.communityEl}
                        open={this.state.open && this.state.communityEl !== null}
                        onClose={this.handleClose}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "center",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "center",
                        }}>
                        <div className="committee-dropdown">
                          <div className="committee-header">
                            <h4 className="dropdown-header">Event Committee</h4>
                            <h4 className="dropdown-header">IAC Executives</h4>
                          </div>
                          <div className="committee-content">
                            <div className="committee-subsection">
                              {this.eventCommittee.map((member, index) => (
                                <Button key={index} className="menu-link-btn" onClick={() => this.navigateTo(`/committee${member.link}`)}>
                                  {member.name}
                                </Button>
                              ))}
                            </div>

                            <div className="committee-divider" />

                            <div className="committee-subsection">
                              {this.IACExecutive.map((member, index) => (
                                <Button key={index} className="menu-link-btn" onClick={() => this.navigateTo(`/committee${member.link}`)}>
                                  {member.name}
                                </Button>
                              ))}
                            </div>
                          </div>
                        </div>
                      </Menu>
                    </>
                  );
                } else {
                  return (
                    <Button
                      key={index}
                      className={`link-btn ${route.name === "Abstract" ? "abstract-btn" : ""}`}
                      onClick={() => this.navigateTo(route.link)}>
                      {route.name}
                    </Button>
                  );
                }
              })}
              <Button
                className="nav-link-btn abstract-btn"
                color="primary"
                variant="outlined"
                style={{ marginRight: "10px" }}
                onClick={() => this.navigateTo("/abstract")}>
                Abstract
              </Button>
              <Button
                className="nav-link-btn abstract-btn"
                color="primary"
                variant="outlined"
                style={{ marginRight: "10px" }}
                onClick={() => this.navigateTo("/workshop")}>
                Workshop
              </Button>
              <Button
                className="nav-link-btn abstract-btn"
                color="primary"
                variant="outlined"
                onClick={() => this.navigateTo("/registration")}>
                Register Now
              </Button>
            </nav>

            <div className="header-menu-bar">
              <MenuIcon fontSize="large" style={{ fill: "#111" }} onClick={() => this.toggleDrawer(true)} />
            </div>
            <Drawer anchor="right" open={this.state.drawerOpen} onClose={(e) => this.toggleDrawer(false)}>
              <div className="drawer-wrapper">
                <div className="drawer-content">
                  <img src="/cytocon-newlogo.png" alt="logo" className="drawer-logo" onClick={() => this.navigateTo("/")} />
                  {this.routes.map((route, index) => {
                    if (route.name === "Committee") {
                      return (
                        <React.Fragment key={index}>
                          <Button key={index} className="link-btn" onClick={(e) => this.handleOpen(e, "community")}>
                            Committee
                          </Button>
                          <Menu
                            anchorEl={this.state.communityEl}
                            open={this.state.open && this.state.communityEl !== null}
                            onClose={this.handleClose}>
                            <div className="committee-content">
                              <div className="committee-subsection">
                                <h4 className="mobile-dropdown-header">Event Committee</h4>
                                {this.eventCommittee.map((member, index) => (
                                  <Button key={index} className="menu-link-btn" onClick={() => this.navigateTo(`/committee${member.link}`)}>
                                    {member.name}
                                  </Button>
                                ))}
                              </div>
                              <div className="committee-subsection">
                                <h4 className="mobile-dropdown-header">IAC Executives</h4>
                                {this.IACExecutive.map((member, index) => (
                                  <Button key={index} className="menu-link-btn" onClick={() => this.navigateTo(`/committee${member.link}`)}>
                                    {member.name}
                                  </Button>
                                ))}
                              </div>
                              {/* <div className="committee-subsection">
                                <h4 className="mobile-dropdown-header">CSI Committee</h4>
                                {this.csiCommittee.map((member, index) => (
                                  <Button key={index} className="menu-link-btn" onClick={() => this.navigateTo(`/committee${member.link}`)}>
                                    {member.name}
                                  </Button>
                                ))}
                              </div> */}
                            </div>
                          </Menu>
                        </React.Fragment>
                      );
                    }
                    return (
                      <Button
                        key={index}
                        className={`link-btn ${route.name === "Abstract" ? "abstract-btn" : ""}`}
                        onClick={() => this.navigateTo(route.link)}>
                        {route.name}
                      </Button>
                    );
                  })}

                  <Button
                    className="nav-link-btn abstract-btn"
                    color="secondary"
                    variant="outlined"
                    onClick={() => this.navigateTo("/abstract")}>
                    Abstract
                  </Button>
                  <Button
                    className="nav-link-btn abstract-btn"
                    color="secondary"
                    variant="outlined"
                    onClick={() => this.navigateTo("/workshop")}>
                    Workshop
                  </Button>
                  <Button
                    className="nav-link-btn abstract-btn"
                    color="secondary"
                    variant="outlined"
                    onClick={() => this.navigateTo("/registration")}>
                    Register Now
                  </Button>
                </div>
              </div>
            </Drawer>
          </div>
        </div>
      </header>
    );
  }
}
